import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { textAlignmentStyle } from '@/_shared';

import { CellText } from './cell-text';
import type { Align } from './types';

export function CellFallback({
  className,
  text,
  align = 'left',
}: {
  align?: Align;
  text?: string | number | ReactNode;
  className?: string;
}) {
  return <CellText className={twMerge(textAlignmentStyle[align], className)}>{text ?? '—'}</CellText>;
}
